import React from 'react'
import { Table } from 'antd';


const index = ({columns, data, scroll,pagination,loading,rowClassName,onChange}) => {
    return <Table className="BasicTable gx-table-responsive " onChange={onChange} rowClassName={rowClassName} loading={loading} columns={columns} dataSource={data} scroll={scroll} pagination={pagination}  />
}

export default index
